import { Http } from '@intelipost-js/secure-providers';

export default {
  getTransactions(context, type) {
    context.commit('toggleLoading', true);

    return Http.get(`api/v1/client/my_downloads/transactions/${type}`)
      .then((res) => {
        context.commit('setTransactions', res.data.content.result);
        context.commit('toggleLoading', false);
      });
  },
};



// WEBPACK FOOTER //
// ./node_modules/@intelipost-modules/secure-order/features/files/transactions/store/actions.js